import styled from "styled-components";
import { COLORS } from "../../../../../../../assets/constants/styles";

export const SummarySection = styled.div`
  background-color: ${COLORS.white};
  border: 2px solid ${COLORS.lightGrey};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 12px;
  align-items: baseline;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.black};
  margin-right: 8px;
  min-width: 120px;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: ${COLORS.grey};
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
`;
